import { Box, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { DrawerType } from '../../../../../../model/contacts.model';
import zeplinColor from '../../../../../../theme/Color';
import CustomButton from '../../../../CustomButton/CustomButton';
import styles from './NoContacts.module.css';

export function NoContacts({
  handleToggleDrawer,
}: {
  handleToggleDrawer: (newType?: DrawerType) => void;
}) {
  const client = useLocation();
  const isHuddleClient = client.pathname.includes('/huddle/');
  const clientId = client.state.client.AccountId;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        height: 'calc(100vh - 380px)',
        width: '100%',
        flex: 1,
        gap: { xs: '16px', xl: '32px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: '6px', xl: '12px' },
        }}
      >
        <img
          src={'/assets/no-contacts.svg'}
          className={styles.noContactsImage}
          alt='no contacts icon'
        />
        <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
          No Contacts Available
        </Typography>
        <Typography
          variant='responsiveBody3'
          color={zeplinColor.Neutral8}
          sx={{ textAlign: 'center' }}
        >
          Add a contact now to get started and keep <br />
          everything handy.
        </Typography>
      </Box>
      {!isHuddleClient ? (
        <Link
          to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Account/${clientId}/related/AccountContactRelations/view`}
          target='_blank'
          rel='noopener noreferrer'
          style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
        >
          <CustomButton
            disabled={false}
            onClick={() => {}}
            variant='outlined'
            color='secondary'
            buttonVariant='responsiveButtonLarge'
            style={{
              borderRadius: { xs: '10px', xl: '14px' },
              height: '48px',
              padding: { xs: '10px 12px', xl: '14px 16px' },
              backgroundColor: zeplinColor.Brand1,
            }}
            textStyle={{ color: zeplinColor.Neutral1 }}
            text={'Add Contacts'}
          />
        </Link>
      ) : (
        <CustomButton
          disabled={false}
          onClick={() => handleToggleDrawer()}
          variant='contained'
          color={'primary'}
          buttonVariant='buttonMedium'
          style={{
            borderRadius: { xs: '10px', xl: '14px' },
            height: { xs: 30, xl: 48 },
            padding: { xs: '10px 12px', xl: '14px 16px' },
            '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
          }}
          textStyle={{ color: zeplinColor.Neutral1 }}
          text={'Add Contact'}
          icon={
            <img src={`/assets/add-white.svg`} className={styles['add-icon']} alt='plus icon' />
          }
        />
      )}
    </Box>
  );
}
